import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import styled from 'styled-components';
import { emphasis } from '../../Theme';
import { useTheme } from '@material-ui/core';
var styledForm = styled('form').withConfig({
  displayName: "Form__styledForm",
  componentId: "sc-158olpg-0"
})(["display:flex;width:100%;justify-content:space-around;"]);
var MajorityRequiredFormGroup = styled(styledForm).withConfig({
  displayName: "Form__MajorityRequiredFormGroup",
  componentId: "sc-158olpg-1"
})([".Mui-required{.MuiFormLabel-asterisk,.MuiInputLabel-asterisk{display:none;}}.MuiFormLabel-root:not(.Mui-required){width:100%;&:after{content:'Optional';position:absolute;right:0;bottom:0;font-size:12px;text-transform:initial;", "}}"], function (props) {
  return _objectSpread({}, emphasis[props.themeType]['low']);
});
var MajorityOptionalFormGroup = styled(styledForm).withConfig({
  displayName: "Form__MajorityOptionalFormGroup",
  componentId: "sc-158olpg-2"
})([""]);

var Form = function Form(_ref) {
  var majorityRequired = _ref.majorityRequired,
      name = _ref.name,
      children = _ref.children,
      body = _ref.body,
      getBodySlot = _ref.getBodySlot;
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  var theme = useTheme();
  return majorityRequired ? /*#__PURE__*/React.createElement(MajorityRequiredFormGroup // @ts-ignore
  , {
    themeType: theme.palette.type,
    name: name,
    ref: bodyCb
  }, body, children) : /*#__PURE__*/React.createElement(MajorityOptionalFormGroup, {
    name: name,
    ref: bodyCb
  }, body, children);
};

export default Form;

try {
  Form.__docgenInfo = {
    description: '',
    displayName: 'Form',
    methods: [],
    props: {
      majorityRequired: {
        defaultValue: null,
        description: '',
        name: 'majorityRequired',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      },
      name: {
        defaultValue: null,
        description: '',
        name: 'name',
        required: false,
        type: {
          name: 'string'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map